import {KeyGenerator} from "@/link-components/table/utils/KeyGenerator";
import {TableNode} from "@/link-components/table/utils/TableNode";
import {createFlagManager} from './NodeUtils';

const generator = new KeyGenerator('table_node')

export interface TableConfig {
	lazy?: boolean,
	according?: boolean,
	keyField?: string,
	childrenField?: string,
	getChildren?: (node: TableNode, cb: (...args: any[]) => void) => void,
	isCheckable?: (node: TableNode) => boolean,
	isLeaf?: (node: TableNode) => boolean,
	filterNodeMethod?: (node: TableNode) => boolean,
	checkStrictly?: boolean,
	autoExpandParent?: boolean,
	checkKeys?: string[],
	flatCheckedData?: boolean,
}

/**
 * 递归遍历树形结构的表格数据
 * @author  韦胜健
 * @date    2020/6/16 16:20
 */
function iterateTableNode(
	tableNodes: TableNode[] | Readonly<TableNode[]> | null,
	fn: (node: TableNode) => void,
	iterateChildren?: (node: TableNode) => boolean
) {
	if (!tableNodes) return
	tableNodes.forEach(node => {
		fn(node)
		if (!!node.children && (!!iterateChildren && iterateChildren(node))) {
			iterateTableNode(node.children, fn, iterateChildren)
		}
	})
}

export class TableMark {
	constructor(
		public config: () => TableConfig,
	) {
		const {checkKeys} = config()
		if (!!checkKeys && checkKeys.length > 0) {
			this.check.state.map = window.Vue.observable(checkKeys.reduce((prev, key) => (prev[key] = true, prev), {} as any))
		}
	}

	static generator = generator

	selfGetter = () => this

	node = {
		state: (window.Vue).observable({map: {}}) as { map: Partial<{ [k: string]: TableNode }> },
		get: (
			row: any,
			level: number,
			parentRef: () => TableNode,
			isSummaryData: boolean,
		): TableNode => {
			const key = generator.get(row, this.config().keyField)
			let node = this.node.state.map[key]
			if (!!node) {
				node.row = row
				node.level = level
				node.parentRef = parentRef
			} else {
				node = new TableNode(
					key,
					row,
					level,
					isSummaryData,
					this.config,
					parentRef,
					this.selfGetter,
				)
				this.node.state.map[key] = node
			}
			return node
		},
		getList: (
			list: any[] | undefined,
			level: number,
			parentRef: () => (TableNode),
			isSummaryData: boolean,
		) => {
			if (!list) return []
			return list.map(item => this.node.get(
				item,
				level,
				parentRef,
				isSummaryData,
			))
		},
		getByKey(key: string) {
			return this.state.map[key]
		},
		flatListData(list: TableNode[]) {
			let index = 0
			const formatDataFlat: TableNode[] = []      // 格式化之后的展开的数据
			let maxShowLevel = 1                        // 树格式数据中，显示的最大层级数

			iterateTableNode(
				list,
				(node) => {
					if (node.level > maxShowLevel) {
						maxShowLevel = node.level
					}
					// 这个index应该是一个非响应式属性，避免出现计算属性死循环的情况
					node.index = index++
					formatDataFlat.push(node)
				},
				(node) => {
					// return !!props.childrenField && node.isExpand
					return node.isExpand
				},
			)

			return {
				formatDataFlat: formatDataFlat.filter(node => node.isVisible),
				maxShowLevel,
			}
		},
	}

	editRow = createFlagManager<any>()
	expand = createFlagManager()
	check = createFlagManager()
	loading = createFlagManager()
	loaded = createFlagManager()
}